<script>
    import { fade } from 'svelte/transition';
    import { quadIn, quadOut } from 'svelte/easing';

    const helpers = ['Friends', 'Teammates', 'Collaborators', 'Small Groups', 'Study Groups', 'Anyone'];
    let idx = 0;
    let show = true;
    let done = false;

    $: helper = helpers[idx].padEnd(15, " ");

    const interval = setInterval(() => {
        if(show && !done) {
            show = false;
            idx++;
        }
        else {
            show = true;
            if(idx >= helpers.length - 1) {
                idx = helpers.length - 1;
                done = true;
            }
        }
    }, 1500);
</script>

<banner>
    <div class="head">
        Schedule video meetings with...
        <br>
        {#if show}
        <span class="helpers" in:fade="{{duration: 500, easing: quadIn}}" out:fade="{{duration: 750, easing: quadOut}}"> {helper}</span>
        {/if}
    </div>
    <p class="subhead">Help Meet is a scheduler for <a href="https://meet.jit.si/">meet.jit.si</a>, a 
    free, secure, open source, video conferencing platform. No account required.</p>
</banner>

<style>
    .head {
        font-size: 1.5em;
        height: 2em;
    }

    .subhead {
        font-size: 0.9em;
        padding: 1em;
    }

</style>